import { render, staticRenderFns } from "./BtnList.vue?vue&type=template&id=016792b7&scoped=true"
import script from "./BtnList.vue?vue&type=script&lang=js"
export * from "./BtnList.vue?vue&type=script&lang=js"
import style0 from "./BtnList.vue?vue&type=style&index=0&id=016792b7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "016792b7",
  null
  
)

export default component.exports